import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICountyWellWaterSystemResult, IRegionWellWaterSystemResult } from '../../../types'
import {
  fetchAggregatedWellWaterSystemsAsync,
  fetchAggregatedWellWaterSystemsAsyncBuilder,
} from './asyncRequests'
import { defaultRegionHousingUnits } from '../../../constants/Map'

export enum ZoomLevel {
  REGION = 'region',
  COUNTY = 'county',  
  GEO_BLOCK = 'geo_block'
}

export interface WellWaterSystemsAggregatesInitialState {
  regionsHousingUnits: IRegionWellWaterSystemResult[]
  countiesHousingUnits: ICountyWellWaterSystemResult[]
  zoomLevel: ZoomLevel
  loading: boolean
  error: string | null
  success: boolean
}

const initialState: WellWaterSystemsAggregatesInitialState = {
  regionsHousingUnits: defaultRegionHousingUnits,
  countiesHousingUnits: [],
  zoomLevel: ZoomLevel.REGION,
  loading: false,
  error: null,
  success: false,
}

export const WellWaterSystemsAggregatesSlice = createSlice({
  name: 'wellWaterSystemAggregateSlice',
  initialState,
  reducers: {
    setZoomLevel: (state, action: PayloadAction<ZoomLevel>) => {
      state.zoomLevel = action.payload
    },
    resetWaterSystemMetricsData: (state) => {
      state.regionsHousingUnits = initialState.regionsHousingUnits
      state.countiesHousingUnits = initialState.countiesHousingUnits
      state.zoomLevel = initialState.zoomLevel
      state.loading = initialState.loading
      state.error = initialState.error
      state.success = initialState.success
    },
  },
  extraReducers: (builder) => {
    fetchAggregatedWellWaterSystemsAsyncBuilder(builder)
  },
})

export const WellWaterSystemsAggregatesActions = {
  ...WellWaterSystemsAggregatesSlice.actions,
  fetchAggregatedWellWaterSystemsAsync,
}

export const WellWaterSystemsAggregatesReducer = WellWaterSystemsAggregatesSlice.reducer
